import styled from "styled-components";

export const SectionAchievementsStamp = styled.section(({ theme }) => ({
    padding: "40px 16px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "103px",
    width: "100%",
    flexDirection: "column",

    [theme.breakpoint.xl()]: {
        padding: "16px 112px 80px 112px",
        flexDirection: "row",
    },
}))

export const ContentAchievementsStamp = styled.div(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
}))

export const TitleAchievementsStamp = styled.h2(({ theme }) => ({
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: "150%",
    margin: 0,
    color: theme.color.neutral["02"],

    [theme.breakpoint.lg()]: {
        fontSize: "32px",
    },
}))

export const ParagraphAchievementsStamp = styled.p(({ theme }) => ({
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "160%",
    margin: 0,
    color: theme.color.neutral["02"],

    [theme.breakpoint.lg()]: {
        fontSize: "20px",
    },
}))

